import { render, staticRenderFns } from "./GoodDamageDetailsForm.vue?vue&type=template&id=b1b565f2&scoped=true"
import script from "./GoodDamageDetailsForm.vue?vue&type=script&lang=ts"
export * from "./GoodDamageDetailsForm.vue?vue&type=script&lang=ts"
import style0 from "./GoodDamageDetailsForm.vue?vue&type=style&index=0&id=b1b565f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b565f2",
  null
  
)

export default component.exports